import React, { useEffect } from 'react';
import 'reactjs-popup/dist/index.css';
import useDebounce from "../../hooks/useDebounce";

export function InputWithDebounce(props) {
    const [value, set_value] = useDebounce('not_use_full__InputWithDebounce', 1500);

    useEffect(() => {
        if (value !== 'not_use_full__InputWithDebounce')
            props.onChange(value);
    }, [value])

    return (
        <>
            <input {...props}
                onChange={(e) => {
                    set_value(e.target.value)
                }}
            />
        </>
    );
}
